<script setup lang="ts">
import type { PaymentHistory } from '@/types/account.types'

defineProps<{
  item: PaymentHistory
}>()

const formatDate = (date: number) => {
  return new Date(date).toLocaleDateString('ko-KR', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}
</script>

<template>
  <div class="payment-item">
    <div class="payment-row">
      <div class="payment-amount body-sm white">{{ item.price.toLocaleString() }}원</div>
      <div class="payment-datetime body-sm white">{{ formatDate(item.purchasedAt) }}</div>
    </div>
    <div class="payment-row">
      <div class="payment-title body-lg white">[{{ item.orderName }}]</div>
    </div>
    <div class="payment-row">
      <div class="payment-id body-sm gray-600">{{ item.orderId }}</div>
      <div class="payment-store body-sm gray-600">{{ item.method }}</div>
    </div>
  </div>
</template>

<style scoped>
.payment-item {
  padding: 0px 0px 12px 0px;
  border-bottom: 1px solid #3b3b3b;
  margin-bottom: 16px;
}

.payment-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
</style>
